import {entroHttpClient} from '@entro-no/common';

const elhubBaseUri = window.ELHUB_API_BASE_URI;
const elhubPaths = {
  eanPath:              '/meter/',
  meterListPath:        '/meter/list',
  setAccessWantedPath:  '/meter/set-access-wanted',
  mailPath:             '/send-email'
};

const enumMeterAccessStatus = {
  ACCEPTED:   'Godkjent',
  DEFAULT:    '',
  ERROR:      'Feil',
  STOPPED:    'Stoppet',
  REQUESTED:  'Venter på godkjenning',
  WANTED:     'Sender forespørsel',

  OK:         'OK',
  ADDING:     'Venter på godkjenning',
  DELETING:   'Fjerner godkjenning',
  ABANDONED:  'Forespørsel gitt opp'
};

const enumActionType = {
  REQUEST: 0,
  REVOKE:  1,
  MAIL:    2
};

function getData() {
  const url = elhubBaseUri + elhubPaths.meterListPath;
  return entroHttpClient.get(url);
}

function getEanData(eanNumber) {
  const url = elhubBaseUri + elhubPaths.eanPath + eanNumber;
  return entroHttpClient.get(url);
}

function setAccessWantedStateOnMultipleItems(data) {
  const url = elhubBaseUri + elhubPaths.setAccessWantedPath;
  return entroHttpClient.post(url, data);
}

function sendMail(data) {
  const url = elhubBaseUri + elhubPaths.mailPath;
  return entroHttpClient.post(url, data);
}

export default {
  enumMeterAccessStatus,
  enumActionType,
  getData,
  getEanData,
  setAccessWantedStateOnMultipleItems,
  sendMail
};
